"use client"

import { motion } from "framer-motion"
import { useLanguage } from "../context/LanguageContext"
import { Link } from "react-router-dom"
import instagramIcon from "../assets/icons/instagram-fill.svg"
import linkedinIcon from "../assets/icons/linkedin-fill.svg"
import facebookIcon from "../assets/icons/facebook-fill.svg"
import { fadeDown, staggerContainer } from "../lib/motion"
import extraLogo from "../assets/images/extra-logo.svg"

export function Footer() {
  const { translation: t, lang } = useLanguage()

  return (
    <footer className="p-5 md:p-7 lg:p-10 xl:p-[3.125rem]">
      <motion.div
        className="text-primary flex flex-col gap-6 flex-wrap w-full"
        variants={staggerContainer(0.12, 0.08)}
        initial="hidden"
        animate="show"
      >
        <motion.div
          className="bg-secondary rounded-3xl p-6 md:p-12 flex flex-col lg:flex-row justify-between xl:justify-between md:gap-12 gap-6 items-center lg:items-start"
          variants={staggerContainer(0.1, 0.06)}
        >
          {/* Logo */}
          <motion.div className="flex min-w-fit items-center justify-end flex-col gap-[5.47px] mt-5 md:mt-0" variants={fadeDown}>
            <img
              src={lang === "ar" ? "/logos/logo-ar.svg" : "/logos/logo.svg"}
              alt="NowPay"
              className="w-[11.25rem] h-auto"
            />
            <div className="flex gap-[15px] w-full justify-end">
                <img src={extraLogo} alt="eXtra" className="w-9 h-auto"/>
            </div>
          </motion.div>

          <motion.div
            className="flex gap-8 md:gap-11 lg:gap-14 xl:gap-[4.375rem] md:flex-row flex-col items-center md:items-start text-center md:text-start text-base leading-[1.375rem]"
            variants={staggerContainer(0.08, 0.04)}
          >
            {/* About / FAQ / Terms / Privacy */}
            <motion.div variants={fadeDown}>
              <Link
                to="/about-us"
                className="hover:text-hoverColor transition-colors link-underline link-underline-thin"
              >
                {t.aboutUs}
              </Link>
              <div>
                <Link
                  to="/faq"
                  className="hover:text-hoverColor transition-colors link-underline link-underline-thin"
                >
                  {t.faq}
                </Link>
              </div>
              <div>
                <Link
                  to="/terms-conditions"
                  className="hover:text-hoverColor transition-colors link-underline link-underline-thin"
                >
                  {t.termsConditions}
                </Link>
              </div>
              <div>
                <Link
                  to="/privacy-policy"
                  className="hover:text-hoverColor transition-colors link-underline link-underline-thin"
                >
                  {t.privacyPolicy}
                </Link>
              </div>
            </motion.div>

            {/* Contacts */}
            <motion.div variants={fadeDown}>
              <h6 className="font-bold">{t.contacts}</h6>
              <p className="max-w-56 md:max-w-48 lg:max-w-56 xl:max-w-[19.5rem] whitespace-pre-line">{t.address}</p>
              <p>{t.phoneNumber}</p>
              <p>{t.email}</p>
            </motion.div>

            {/* Social Icons + Copyright in same column */}
            <motion.div className=" flex flex-1 flex-col gap-4 items-center md:items-start" variants={fadeDown}>
              <div className="flex items-center gap-[1.125rem]">
                <Link
                  to="https://www.linkedin.com/company/nowpay/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-6 h-6 rounded flex items-center justify-center hover-scale"
                  aria-label="LinkedIn"
                >
                  <img src={linkedinIcon} alt="LinkedIn" className="w-full h-full" />
                </Link>
                <Link
                  to="https://www.instagram.com/nowpayapp/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-6 h-6 rounded flex items-center justify-center hover-scale"
                  aria-label="Instagram"
                >
                  <img src={instagramIcon} alt="Instagram" className="w-full h-full" />
                </Link>
                <Link
                  to="https://www.facebook.com/NowPayDotCash"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-6 h-6 rounded flex items-center justify-center hover-scale"
                  aria-label="Facebook"
                >
                  <img src={facebookIcon} alt="Facebook" className="w-full h-full" />
                </Link>
              </div>
              <div className="text-base mb-5 md:mb-0 text-primary text-center md:text-start max-w-[22rem]">
              {t.allRightsReserved}
              </div>
            </motion.div>
          </motion.div>
        </motion.div>
      </motion.div>
    </footer>
  )
}
